import FilterListIcon from '@mui/icons-material/FilterList';
import { Tooltip, Popover, Box, Button } from '@mui/material';
import { isNil } from 'lodash';
import { useState } from 'react';
import type { FC, MouseEvent } from 'react';

const TableToolbar: FC<TableToolbarProps> = ({
  FilterComponent,
  onApplyFilters,
  onCloseFilters,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClick = (event: MouseEvent<HTMLButtonElement>): void => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (): void => {
    setAnchorEl(null);

    !isNil(onCloseFilters) && onCloseFilters();
  };

  const open = Boolean(anchorEl);
  const id = open ? 'order-state-filter-popover' : undefined;

  return (
    <Box p={1}>
      <Tooltip title={'Фильтр'}>
        <Button
          variant='text'
          size='small'
          startIcon={<FilterListIcon />}
          onClick={handleClick}
          aria-describedby={id}>
          Фильтр
        </Button>
      </Tooltip>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        slotProps={{ paper: { sx: { p: 2, width: 300 } } }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}>
        <FilterComponent />
        <Button sx={{ mt: 2 }} variant='contained' size='small' onClick={onApplyFilters}>
          Применить
        </Button>
      </Popover>
    </Box>
  );
};

export interface TableToolbarProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  FilterComponent: React.JSXElementConstructor<any>;
  onApplyFilters?: VoidFunction;
  onCloseFilters?: VoidFunction;
}

export default TableToolbar;
